import styled from "styled-components"

const NavigationItemContainer = styled.li`
  margin: 0;
  padding: 0 20px;
  list-style: none;
  display: flex;
  align-items: center;
  height: 60px;
  flex-grow: 1;
  cursor: pointer;
  pointer-events: ${props => (props.active ? "auto" : "none")};
  border-left: 1px solid #aaabab;

  &:first-child {
    border-left: none;
  }
`

export default NavigationItemContainer



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationItemContainer.js